export const unsubscribe = {
  title: "Cancelar inscrição",
  subtitle: "Deseja realmente cancelar sua inscrição a esse e-mail?",
  success: 'Inscrição revogada com sucesso',
  confirm: 'Confirmar',
  operationDoneTitle: 'Inscrição revogada',
  operationDoneSubtitle: 'Você não receberá mais e-mails dessa lista! Esta página pode ser fechada.',
};
